import { CountUp } from "countup.js";
const typeOf = type => object => Object.prototype.toString.call(object) === `[object ${type}]`;
const isFunction = typeOf("Function");
export default {
  __countup__: CountUp,
  name: "VueCountUp",
  props: {
    delay: {
      type: Number,
      required: false,
      default: 0
    },
    endVal: {
      type: Number,
      required: true
    },
    options: {
      type: Object,
      required: false
    },
    useUnit: {
      // 👈 新增单位格式化开关
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      instance: null
    };
  },
  watch: {
    endVal(value) {
      const that = this;
      if (that.instance && isFunction(that.instance.update)) {
        if (that.useUnit) {
          that.printValue(value); // 👈 手动格式化更新
        } else {
          that.instance.update(value); // 默认动画更新
        }
      }
    }
  },

  methods: {
    formatWithUnit(value) {
      const units = [{
        value: 1e24,
        symbol: "Sp"
      }, {
        value: 1e21,
        symbol: "Sx"
      }, {
        value: 1e18,
        symbol: "Qn"
      }, {
        value: 1e15,
        symbol: "Q"
      }, {
        value: 1e12,
        symbol: "T"
      }, {
        value: 1e9,
        symbol: "B"
      }, {
        value: 1e6,
        symbol: "M"
      }, {
        value: 1e3,
        symbol: "K"
      }];
      for (const unit of units) {
        if (value >= unit.value) {
          const num = value / unit.value;
          const fixed = num.toFixed(2);
          return fixed.endsWith(".00") ? Math.round(num) + unit.symbol : fixed + unit.symbol;
        }
      }
      return value.toString();
    },
    create() {
      const that = this;
      if (that.instance) return;
      const dom = that.$el;
      const instance = new CountUp(dom, that.endVal, that.options);
      if (instance.error) return;
      that.instance = instance;
      if (that.delay < 0) {
        that.printValue(that.endVal); // 👈 初始化显示
        that.$emit("ready", instance, CountUp);
        return;
      }
      setTimeout(() => {
        if (that.useUnit) {
          // 先正常启动动画，然后格式化展示单位
          instance.start(() => {
            that.printValue(that.endVal);
            that.$emit("ready", instance, CountUp);
          });
        } else {
          instance.start(() => that.$emit("ready", instance, CountUp));
        }
      }, that.delay);
    },
    destroy() {
      this.instance = null;
    },
    printValue(value) {
      const that = this;
      if (!that.instance) return;
      if (that.useUnit) {
        that.$el.innerText = that.formatWithUnit(value); // 👈 格式化文本
      } else if (isFunction(that.instance.printValue)) {
        that.instance.printValue(value);
      }
    },
    start(callback) {
      if (this.instance && isFunction(this.instance.start)) {
        return this.instance.start(callback);
      }
    },
    pauseResume() {
      if (this.instance && isFunction(this.instance.pauseResume)) {
        return this.instance.pauseResume();
      }
    },
    reset() {
      if (this.instance && isFunction(this.instance.reset)) {
        return this.instance.reset();
      }
    },
    update(newEndVal) {
      if (this.instance && isFunction(this.instance.update)) {
        if (this.useUnit) {
          this.printValue(newEndVal);
        } else {
          return this.instance.update(newEndVal);
        }
      }
    }
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    this.destroy();
  }
};